export const containerStyles = {
  display: 'flex',
  justifyContent: ['center', 'center', 'initial'],
}

export const getImageStyles = (isOverlapping?: boolean) => ({
  alignSelf: 'center',
  display: ['none', 'none', 'flex'],
  width: isOverlapping ? ['80%', '400px', '100%', '100%', '100%'] : ['80%', '400px', '420px', '450px', '480px'],
  objectFit: 'contain',
  position: isOverlapping ? 'absolute' : 'static',
  left: '0',
  top: '-100px',
})

export const getMobileImageStyles = (isOverlapping?: boolean, mobileFullWidth?: boolean) => ({
  display: ['flex', 'flex', 'none'],
  width: mobileFullWidth ? ['100vw', '100vw', '420px', '450px', '480px'] : ['100%', '400px', '420px', '450px', '480px'],
  objectFit: 'contain',
  alignSelf: 'center',
  margin: isOverlapping ? '-2rem' : '0px',
  position: isOverlapping ? 'relative' : 'static',
  left: '0',
  top: '-2.2rem',
})
